import { constants, mixpanel } from 'common/helpers'


type ProcessRecurlyRefundProps = {
  decision: 'REFUND' | 'RECEIVE'
  status: string
  transactionType: 'PAUSE' | 'SKIP' | 'UNSUBSCRIBE'
}

// TODO discuss with Alex Chumakov - added on 2020-05-29 by maddoger
const refundTimeByStatus = {
  'AVAILABLE_NEW_SUBSCRIBER': 'before 12 hours',
}

const processRecurlyRefund = (props: ProcessRecurlyRefundProps) => {
  const { decision, status, transactionType = 'UNSUBSCRIBE' } = props

  let eventName = constants.analyticsEvents.unsubscribe

  if (transactionType !== 'UNSUBSCRIBE') {
    eventName = `${transactionType} choose option`
  }

  const typeCancel = decision === 'REFUND' ? 'refund' : 'keep'

  mixpanel.track(eventName, {
    'type time': refundTimeByStatus[status],
    'type cancel': typeCancel,
    'type transaction': transactionType,
  })
}


export default processRecurlyRefund
